import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'
import {
  Button,
  Col,
  Dropdown,
  MenuItem,
  Row
} from 'react-bootstrap'
import Loadable from 'react-loading-overlay'

@observer(['companies', 'globals', 'invoices', 'quickbooks'])
export default class SavedCardForm extends Component {

  constructor(props) {
    super(props)

    this.state = {
      selectedSourceText: 'Select Card',
      selectedSourceId: 0,
      paymentButtonState: true,
      loadableState: true
    }

    this.getStripeSources(props)
  }

  getStripeSources(props) {
    this.setState({
      loadableState: true
    })

    props.companies.getStripeSourcesByStripeCustomerId(props.invoice.stripeCustomerId, () => {
      this.setState({
        loadableState: false
      })
    })
  }

  payWithSavedCard() {
    console.log('Use this card: ', this.state.selectedSourceId)
    this.setState({
      loadableState: true
    })

    //We need to remove the "." form the total dollar amount for Stripe.
    var total = this.props.invoice.oneTimeTotal.replace('.', '');

    const params = {
      organizationId: this.props.invoice.organizationId,
      invoiceToken: this.props.invoice.token,
      stripeCustomerId: this.props.invoice.stripeCustomerId,
      stripeCardId: this.state.selectedSourceId,
      total: total,
      email: this.props.invoice.defaultContactEmail
    }

    this.props.quickbooks.processExistingCustomerPayment(params, (data) => {
      if (!data || !data.quickbooksExistingBillPayment) {
        alert('We were unable to process your payment. Please try again or contact GPS Leaders.')
        this.setState({
          loadableState: false
        })
        return
      }
      if (data.quickbooksExistingBillPayment.statusCode == 200) {
        browserHistory.push('/paymentconfirmation')
      }
      else {
        alert(data.quickbooksExistingBillPayment.data.message)
        this.setState({
          loadableState: false
        })
      }
    })
  }

  onSourceSelect(value, e) {
    this.setState({
      selectedSourceId: value,
      selectedSourceText: e.target.text,
      paymentButtonState: false
    })
  }

  render() {

    let paymentOptionDropdown = 'Loading...'

    paymentOptionDropdown = (
      <Dropdown>
        <Dropdown.Toggle>{this.state.selectedSourceText}</Dropdown.Toggle>
        <Dropdown.Menu onSelect={this.onSourceSelect.bind(this)}>
          {
            this.props.companies.sources
              ? this.props.companies.sources.map((source) => (
                <MenuItem eventKey={source.id}>**** **** **** {source.last4} - Saved {source.dateCreated}</MenuItem>
              ))
              : ''
          }
        </Dropdown.Menu>
      </Dropdown>
    )

    return (
      <div>
        <Loadable active={this.state.loadableState} spinner text='Processing your request...'>
          <Row>
            <Col>{paymentOptionDropdown}</Col>
          </Row>
          <Row>
            <Col><Button onClick={this.payWithSavedCard.bind(this)} bsStyle="success" disabled={this.state.paymentButtonState}>Submit Payment</Button></Col>
          </Row>
        </Loadable>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/invoices/savedcardform.js